// Avoid `console` errors in browsers that lack a console.
(function () {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while ( length-- ) {
        method = methods[length];

        // Only stub undefined methods.
        if ( !console[method] ) {
            console[method] = noop;
        }
    }
}());

export const createInfoLogger = ( label = '[Unknown Logging Group]', state = {} ) => {
    if ( process.env.NODE_ENV === 'development' ) {
        console.groupCollapsed( label );
        Object.entries( state ).forEach( ( [key, value] ) => {
            console.info( key, value );
        } )
        console.groupEnd();
    }
}
